import { FC } from 'react';
import { SecondaryButtonProps } from './types';

const PrimaryButtonDark: FC<SecondaryButtonProps> = (props) => {
	return (
		<button
			className={
				`pop-btn2 pop-shadow-lg
				${props.isDisabled ?
					'disabled:pop-bg-popsizeNeutral10 disabled:pop-text-popsizeNeutral20 pop-border-none pop-w-[75%]' : `pop-w-[75%] pop-bg-popsizeGradientPrimary9050 pop-text-popsizePrimary10 hover:pop-bg-popsizePrimary50 hover:pop-text-popsizePrimary20
					${props.className ? props.className : ''}
					`}
					`}
			onClick={props.onClick}
			disabled={props.isDisabled}
		>
			{props.isLoading ? <span className="pop-loading pop-loading-dots pop-loading-md"></span> : props.children}
		</button>
	);
};

export default PrimaryButtonDark;
